// src/feed/reactions.ts
//
// Heart and unheart a feed item. Each reaction is a doc in
// /feed_items/{id}/reactions/{my_uid} — using my uid as the doc id
// guarantees one reaction per user via natural uniqueness.
//
// On reaction CREATE, a Cloud Function:
//   • bumps reactions_count on /feed_items/{id}
//   • creates a 'shared_reaction' feed_item on the reactor's feed
//   • fans the shared_reaction out to the reactor's followers
//
// On reaction DELETE, the function decrements the count and removes
// any shared_reaction feed item that was created from this reaction.

import {
  deleteDoc,
  doc,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';
import { auth, db } from '../services/firebase';
import { ReactionType } from './types';

export async function reactToFeedItem(
  itemId: string,
  type: ReactionType = 'heart'
): Promise<boolean> {
  const me = auth.currentUser;
  if (!me) return false;
  if (me.isAnonymous) return false;
  try {
    await setDoc(doc(db, 'feed_items', itemId, 'reactions', me.uid), {
      type,
      created_at: serverTimestamp(),
    });
    return true;
  } catch (err) {
    console.warn('reactToFeedItem failed:', err);
    return false;
  }
}

export async function unreactToFeedItem(itemId: string): Promise<boolean> {
  const me = auth.currentUser;
  if (!me) return false;
  try {
    await deleteDoc(doc(db, 'feed_items', itemId, 'reactions', me.uid));
    return true;
  } catch (err) {
    console.warn('unreactToFeedItem failed:', err);
    return false;
  }
}
